import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { API_URL } from "../../../config";
import { useLocation, useNavigate } from "react-router-dom";

const ChangeCapnoDistributor = ({
  deviceid,
  distributor,
  changeDistributorToggleModal,
  successechangedeviceModal,
  godevicelist,
  handleDistList,
  deviceCount,
}) => {
  const navigation = useNavigate();
  const location = useLocation();
  const [changeDistId, setChangeDistId] = useState("");
  const [errorMessege, setErrorMessege] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    getgodevicebyid();
  }, []);

  const HandleEditdeviceType = (e) => {
    setChangeDistId(e.target.value);
    setErrorMessege(false);
  };

  const getgodevicebyid = () => {
    fetch(API_URL + "/get/all/distributer", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setData(resp.data);
        });
      }
    });
  };

  const editDevice = () => {
    let changeDist = {};
    if (changeDistId == "") {
      setErrorMessege(true);
      return false;
    } else {
      changeDist["transfer_distributer"] = changeDistId;
    }
    fetch(API_URL + "/transfer/distributer/capno-go/by/" + deviceid, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(changeDist),
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          changeDistributorToggleModal();
          successechangedeviceModal();
          if (deviceCount == 1) {
            setTimeout(() => {
              navigation(`${location.pathname}` + "?dist=" + "all");
            }, 3000);
          } else {
            handleDistList();
            godevicelist();
          }
        });
      } else if (response.status == 400) {
        devicekeyToggleModal();
      } else {
        alert("network error");
      }
    });
  };

  return (
    <div>
      <ul className="deviceformlist">
        <li>
          <div className="select-device-type">
            <select onChange={HandleEditdeviceType}>
              <option value="">Select distributor</option>
              {data.length > 0 &&
                data?.map((item) => {
                  if (
                    item.firstname == "" ||
                    item.lastname == "" ||
                    item.firstname == null ||
                    item.lastname == null
                  ) {
                  } else {
                    return (
                      <option
                        value={item.eid}
                        selected={item.eid == distributor ? "selected" : ""}
                      >
                        {item.firstname} {item.lastname}
                      </option>
                    );
                  }
                })}
            </select>
          </div>
          {errorMessege && <p className="error-message">Field required </p>}
        </li>

        <li>
          <div className="addBtn">
            <button onClick={editDevice}>Update</button>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default ChangeCapnoDistributor;
